import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import Spinner from 'components/ui-elements/Spinner';
import { useSearchParams } from 'hooks/useSearchParams';
import { userService } from 'services/user/userService';

export const ConfirmEmail = () => {
  const { token } = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    userService
      .activateEmail(token)
      .then(() => navigate('/confirm-email-success'))
      .catch(() => navigate('/confirm-email-error'));
  }, []);

  return <Spinner />;
};
